<template>
    <div>
        <main class="authentication">
            <div class="authentication__content" dusk="registration-success">
                <div class="authentication__form authentication__form--registration">
                    <h1 class="authentication__form-title">
                        {{ trans('authentication.register.confirmation.title') }}
                    </h1>

                    <div class="authentication__form-content">
                        {{ trans('authentication.register.confirmation.message') }}
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: trans('page.register.confirmation')
    }
};
</script>
